var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.3705H17.4102L15.5352 16.2455H19.5C19.8446 16.2455 20.125 16.5259 20.125 16.8705V19.9955C20.125 20.3401 19.8446 20.6205 19.5 20.6205H4.5C4.15539 20.6205 3.875 20.3401 3.875 19.9955V16.8705C3.875 16.5267 4.15547 16.2455 4.5 16.2455H8.46484L6.58984 14.3705H4.5C3.11914 14.3705 2 15.4896 2 16.8705V19.9955C2 21.3763 3.11914 22.4955 4.5 22.4955H19.5C20.8809 22.4955 22 21.3763 22 19.9955V16.8705C22 15.4916 20.8789 14.3705 19.5 14.3705ZM18.875 18.433C18.875 17.915 18.4551 17.4955 17.9375 17.4955C17.4199 17.4955 17 17.9135 17 18.433C17 18.9506 17.4199 19.3705 17.9375 19.3705C18.4551 19.3705 18.875 18.9525 18.875 18.433ZM11.3359 16.8744C11.5195 17.0931 11.7578 17.183 12 17.183C12.2422 17.183 12.4797 17.0914 12.6629 16.9083L17.9754 11.5958C18.3416 11.2296 18.3416 10.6365 17.9754 10.2701C17.6092 9.90365 17.016 9.90384 16.6496 10.2701L12.9375 13.9838V3.43298C12.9375 2.91541 12.5195 2.49548 12 2.49548C11.4805 2.49548 11.0625 2.91541 11.0625 3.43298V13.9838L7.31641 10.2689C6.9502 9.90271 6.35703 9.90271 5.99063 10.2689C5.62422 10.6351 5.62441 11.2283 5.99063 11.5947L11.3359 16.8744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.2a915f9249067d0f834888d3a0f1d47c.svg";
export { ForwardRef as ReactComponent };